import React from "react";
import { LayoutMain, StaticPageLayout, GoToTop } from "../../components/common";

function Dsgvo({ headline = "DATENSCHUTZ" }) {
  return (
    <LayoutMain>
      <StaticPageLayout title={headline}>
        <GoToTop />
        <p>
          Wir möchten Sie darauf aufmerksam machen, dass wir keine Daten über
          Sie oder Ihr Nutzungsverhalten auf dieser Webseite oder im Internet
          sammeln bzw. sammeln lassen. Wir wissen, dass Rückmeldungen zu
          Nutzungsverhalten auf der Webseite und zu den angebotenen Produkten
          für Unternehmen wichtig sind. Dies wird oft über Angebote
          US-amerikanischer Konzerne abgewickelt, womit auch persönliche Daten
          über das Nutzungsverhalten für weitere Zwecke abfließen. Wir möchten
          Sie schützen und bitten Sie daher uns für Rückmeldungen zu Produkten,
          Webseite, etc… persönlich per E-Mail unter{" "}
          <a href="mailto:info@kamikaze-travel.at">info@kamikaze-travel.at</a>{" "}
          zu kontaktieren. Nur gemeinsam können wir uns weiterentwickeln. <br />
          Vielen Dank!
        </p>
        <h3>Widerruf, Änderungen, Berichtigungen und Aktualisierungen</h3>
        <p>
          Der Nutzer hat das Recht, auf Antrag unentgeltlich Auskunft zu
          erhalten über die personenbezogenen Daten, die über ihn gespeichert
          wurden. Zusätzlich hat der Nutzer das Recht auf Berichtigung
          unrichtiger Daten, Sperrung und Löschung seiner personenbezogenen
          Daten, soweit dem keine gesetzliche Aufbewahrungspflicht
          entgegensteht.
        </p>
        <h3>Bildrechte</h3>
        <p>
          Die auf der KaMikaze Travel Homepage dargestellten Bilder sind aus der
          privaten Sammlung. Das Copyright liegt bei Mag. Michael Reisecker und
          Katharina Kortschak,MA.
        </p>
      </StaticPageLayout>
    </LayoutMain>
  );
}

export default Dsgvo;
